import React from 'react'
import { useNavigate } from 'react-router-dom'

import { FormattedMessage } from '@divvy-web/i18n'
import { BannerType } from '@divvy-web/skylab.banner'
import TextLink, { TextLinkSizes } from '@divvy-web/skylab.textlink'

import useGetCreditAppTypes from '@sputnik/hooks/useGetCreditAppTypes'
import StatusBanner from '@sputnik/pages/DashboardPages/CreditApplicationsDataGrid/DashboardDetailsDrawer/ApplicationDetailsTabContent/ActionsNeededSection/StatusBanner'
import { PATHNAME_CONSTS } from '@sputnik/resources/constants'

interface CorrectionNeededBannerProps {
  salesforceCreditId: string
}

// this banner will show when the status is CORRECTION_REQUESTED (or whatever the new actions needs correction status is called)
const CorrectionNeededBanner = ({ salesforceCreditId }: CorrectionNeededBannerProps) => {
  const navigate = useNavigate()
  const { isAppVersion3, isLoadingCreditAppTypes } = useGetCreditAppTypes({
    salesforceCreditId: salesforceCreditId || '',
  })

  const onMakeCorrectionsClick = () => {
    const navPath = isAppVersion3
      ? `/app/${salesforceCreditId}/${PATHNAME_CONSTS.REVIEW_PATH}`
      : `/app/${salesforceCreditId}/section/${PATHNAME_CONSTS.REVIEW_AND_SIGN_PATH}`

    navigate(navPath)
  }

  return (
    <div className='fs-unmask'>
      <StatusBanner
        bannerType={BannerType.Warning}
        subtext={
          <FormattedMessage
            defaultMessage="Some of the information submitted doesn't match our records and needs to be corrected. <link>Make corrections</link>"
            id='sputnik.CorrectionNeededBanner__dezVS5'
            values={{
              link: (chunks) => (
                <TextLink
                  disabled={isLoadingCreditAppTypes}
                  size={TextLinkSizes.SMALL}
                  onClick={() => onMakeCorrectionsClick()}
                >
                  {chunks}
                </TextLink>
              ),
            }}
          />
        }
        title={
          <FormattedMessage
            defaultMessage='Correction needed'
            id='sputnik.CorrectionNeededBanner__1JRfgv'
          />
        }
      />
    </div>
  )
}

export default CorrectionNeededBanner
